import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DeleteBootingAPI } from "api/bootingRevenueApi";
import { GetBootingAPI } from "api/bootingRevenueApi";
import { CreateUpdateBootingAPI } from "api/bootingRevenueApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  bootingList: [],
  totalBootings: 0,
  loading: false,
};

export const createAndUpdateBooting = createAsyncThunk(
  "bootingRevenue/createAndUpdateBooting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CreateUpdateBootingAPI(data);
      return response.data;
    } catch (err) {
      console.log("booting revenue error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getBootings = createAsyncThunk(
  "bootingRevenue/getBootings",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetBootingAPI(data);
      return response.data;
    } catch (err) {
      console.log("booting revenue error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const deleteBooting = createAsyncThunk(
  "bootingRevenue/deleteBooting",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await DeleteBootingAPI(data);
      return response.data;
    } catch (err) {
      console.log("Delete error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const bootingRevenueSlice = createSlice({
  name: "bootingRevenue",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getBootings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBootings.fulfilled, (state, { payload }) => {
        state.bootingList = payload.bootingList;
        state.totalBootings = payload.total;
        state.loading = false;
      })
      .addCase(getBootings.rejected, (state) => {
        state.loading = false;
      }),
});

export default bootingRevenueSlice.reducer;
